import { FC, Fragment, useEffect, useRef, useState } from 'react';
import { Form, Input, List, Typography } from 'antd';

import CardC from 'src/components/Card';
import Image from 'src/components/Image';
import { HISTORY_SEARCH_KEYWORDS_PENYAKIT } from 'src/constants/localStorage';
import { ISearchResultArticleByGroup } from 'src/interface/ArticleByGroup';
import useComponentVisible from 'src/utils/hook/useComponentVisible';

import classes from './style.module.css';

interface InfoPenyakitSearchProps {
	placeholder?: string;
	search: string;
	setSearch: (search: string) => void;
	searchType?: string;
	result: ISearchResultArticleByGroup[];
	visibleOption: boolean;
	setVisibleOption: (open: boolean) => void;
	onSearch: (search?: string) => void;
	onFocus: () => void;
	loading: boolean;
}

const InfoPenyakitSearch: FC<InfoPenyakitSearchProps> = (props: InfoPenyakitSearchProps) => {
	const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

	const [options, setOptions] = useState<ISearchResultArticleByGroup[]>([]);
	const [hoverOption, setHoverOption] = useState<boolean>(false);
	const [history, setHistory] = useState<string[]>([]);
	const inputRef = useRef<any>(null);

	const handleSearch = (e: any) => {
		const value: string = e.target?.value ?? props.search;
		props.setSearch(value);
		setIsComponentVisible(true);
	};

	const deleteHistorySearchKeyword = (keyword: string) => {
		const historySearchKeywords: string[] = JSON.parse(
			localStorage.getItem(HISTORY_SEARCH_KEYWORDS_PENYAKIT) as string,
		);
		const newData = historySearchKeywords.filter((h) => h !== keyword);
		setHistory(newData);
		localStorage.setItem(HISTORY_SEARCH_KEYWORDS_PENYAKIT, JSON.stringify(newData));
	};

	const clearHistorySearchKeywords = () => {
		setHistory([]);
		localStorage.removeItem(HISTORY_SEARCH_KEYWORDS_PENYAKIT);
	};

	useEffect(() => {
		setOptions(props.result);
		if (typeof window !== 'undefined')
			setHistory(
				JSON.parse(localStorage.getItem(HISTORY_SEARCH_KEYWORDS_PENYAKIT) as string) ?? [],
			);
	}, [props.result]);

	return (
		<Fragment>
			<Form autoComplete="off" className={classes['auto-complete']}>
				<Input
					name="search"
					size="large"
					ref={inputRef}
					placeholder={props.placeholder ?? 'Cari Nama Dokter, Spesialisasi'}
					prefix={<Image alt="Icon Search" src="/icons/search.svg" height={16} width={16} />}
					value={props.search}
					onClick={handleSearch}
					onChange={handleSearch}
					onFocus={() => {
						props.setVisibleOption(true);
						props.onFocus();
					}}
					onBlur={() => !hoverOption && props.setVisibleOption(false)}
					onKeyPress={(e) => {
						if (e.key === 'Enter') {
							props.onSearch();
						}
					}}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							inputRef.current.blur();
							props.onSearch();
						}
					}}
				/>
			</Form>

			<div ref={ref}>
				{isComponentVisible &&
					props.visibleOption &&
					(!props.search ? (
						<CardC
							className={classes.card}
							onMouseOver={() => setHoverOption(true)}
							onMouseLeave={() => setHoverOption(false)}
						>
							<Typography className={classes.historyTitle}>
								Terakhir dicari{' '}
								<span className={classes.clear} onClick={clearHistorySearchKeywords}>
									Hapus Semua
								</span>
							</Typography>
							<List
								dataSource={history}
								className={classes.list}
								renderItem={(search: string) => {
									return (
										<Typography.Text
											className={classes.searchHistory}
											onClick={() => {
												props.setVisibleOption(false);
												props.setSearch(search);
												props.onSearch(search);
											}}
										>
											<div className={classes.listItem}>
												<Image
													alt="clock-icon"
													src="/images/icon/clock.png"
													width={20}
													height={20}
												/>
												<p>{search}</p>
											</div>
											<Image
												alt="close-icon"
												src="/images/icon/close.png"
												width={18}
												height={18}
												onClick={(e: any) => {
													e.stopPropagation();
													deleteHistorySearchKeyword(search);
												}}
											/>
										</Typography.Text>
									);
								}}
								loading={props.loading}
							/>
						</CardC>
					) : (
						<CardC
							className={classes.card}
							onMouseOver={() => setHoverOption(true)}
							onMouseLeave={() => setHoverOption(false)}
						>
							<List
								dataSource={options}
								className={classes.list}
								renderItem={(search: any) => {
									return (
										<div
											onClick={() => {
												props.setVisibleOption(false);
												props.setSearch(search.document.title);
												props.onSearch(search.document.title);
											}}
										>
											<Typography className={classes.searchWord}>
												{search.highlights[0]?.snippet && (
													<div dangerouslySetInnerHTML={{ __html: search.highlights[0].snippet }} />
												)}
											</Typography>
										</div>
									);
								}}
								loading={props.loading}
							/>
						</CardC>
					))}
			</div>
		</Fragment>
	);
};

export default InfoPenyakitSearch;
